import { FlightDeckLoadingElement } from '../../components/shared/flight-deck-spinner'

export const LoadingElement = () => {
  return <FlightDeckLoadingElement />
}
